import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../atoms/const';

interface VendingMachine {
  value: string
}

export interface Client {
  'id': number,
  'name': string,
  'address': string,
  'category': string,
  'lat': string | number,
  'lng': string | number,
  'vendingMachines': VendingMachine[],
  'removed': number,
  'removalDate': Date,
  'commission': string | number,
  'partnerCommission': string | number,
  'contactPerson': any[],
  'numberOfVendingMachines': number,
  'ocsbilling': number
}

interface RemovedClients {
  routeId: number;
  clientId: number;
}

interface PostRoute {
  name: string;
  day: number | string;
  clients: number[] | string[];
  userId:number | string;
  routeId?: number | string;
}

const getAll = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-routes`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getById = (id: string | number | undefined) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-route?routeId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const deleteClient = (removedClients : RemovedClients) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}remove-client-from-route`;
  const data = removedClients;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const add = (data: PostRoute) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-new-route`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const update = (data: PostRoute) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-route`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const deleteById = (data : {routeId: number}) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}cancel-route`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const getAllDrivers = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}all-users-by-role?roleId=3&deleted=0`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const routes = {
  getAll,
  getById,
  deleteClient,
  update,
  add,
  deleteById,
  getAllDrivers,
};

export default routes;
